import { range } from 'lodash-es';
import { GridItem, WithInfoIcon, Checkbox, Typography, TextField, MenuItem } from 'seagull';
import styles from "./ExpirationDate.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ExpirationDate = _ref => {
  let {
    daysToExpiration,
    hasExpirationDate,
    disabled,
    setDaysToExpiration,
    setHasExpirationDate
  } = _ref;
  return /*#__PURE__*/_jsxs(GridItem, {
    span: 12,
    "data-testid": "expiration-date",
    children: [/*#__PURE__*/_jsx(WithInfoIcon, {
      info: "Set the number of days after which the proposal will expire. After the expiration date your client will not be able to sign or access the proposal.",
      infoTestId: "expiration-date-tooltip",
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: hasExpirationDate,
        disabled: disabled,
        onChange: e => setHasExpirationDate(e.target.checked),
        "data-testid": "expiration-date-checkbox",
        children: /*#__PURE__*/_jsx(Typography, {
          children: "Set an expiration for this proposal"
        })
      })
    }), hasExpirationDate && /*#__PURE__*/_jsxs(Typography, {
      className: styles.days,
      children: ["The proposal expires", /*#__PURE__*/_jsx(TextField, {
        size: "small",
        width: 70,
        select: true,
        disabled: disabled,
        value: daysToExpiration,
        onChange: e => setDaysToExpiration(+e.target.value),
        "data-testid": "expiration-days-select",
        children: range(1, 91).map(day => /*#__PURE__*/_jsx(MenuItem, {
          value: day + '',
          "data-testid": "expiration-days-select-item-".concat(day),
          children: day
        }, day))
      }), "days after sending"]
    })]
  });
};
export default ExpirationDate;